<template lang="html">
  <masked-input
    type="text"
    class="text-left form-control"
    :class="['is-' + state]"
    :id="id"
    v-model="phone"
    @change="callChange"
    @keyup="callKeyUp"
    placeholder="(00) 0000-0000"
    :mask="setPhoneNumber"
    :guide="false"
  ></masked-input>
</template>

<script>
import MaskedInput from 'vue-text-mask';

export default {
  name: 'InputCurrency',
  components: {
    MaskedInput,
  },
  props: {
    placeholder: {
      type: String,
      default: 'Total',
    },
    model: {
      required: true,
      default: null,
    },
    id: {
      type: String,
      default: '',
    },
    state: {
      type: String,
      default: null,
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    onKeyup: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    phone: {
      get() {
        return this.model;
      },
      set(val) {
        this.$emit('update:model', val);
      },
    },
  },
  mounted() {
    this.phone = this.model;
  },
  watch: {
    phone(newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }

      this.$emit('input', newVal);
    },
  },
  methods: {
    callChange(e) {
      this.$emit('change', e.target.value);
      this.onChange(this.model);
    },
    callKeyUp() {
      this.onKeyup(this.model);
    },
    setPhoneNumber(rawValue) {
      if (rawValue.length < 15) {
        return ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      }
      return ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    },
  },
};
</script>
